import Toolkit from '../utils/utils';
let { orderAnimate, animCondition, animateInfo } = Toolkit.commonFunction;

class Anim {

	constructor(selector, effect) {
		this.selector = selector;
		this.effect = effect;
		this.offset = 150;
		this.factor();
	}

	// 加工函数
	factor() {
		this.sets = animateInfo(this.selector);
	}

	doit() {
		for(let i in this.sets) {
			if(animCondition(this.sets[i], this.offset)) {
				orderAnimate(this.selector.eq(i), this.effect, i, 150, 850);
				this.sets[i].animated = false;
			}
		}
	}
}

module.exports = Anim;


// WEBPACK FOOTER //
// ./js/utils/doAnim.js